<template>
  <div class="pagination border border-primary rounded-pill py-1 my-4">
    <button class="btn btn-sm border-0" @click="goToPreviousPage"
      :disabled="currentPage === 1"><i class="fa-solid fa-angles-left"></i> </button>
    <span>Página {{ currentPage }} de {{ totalPages }}</span>
    <button class="btn btn-sm border-0" @click="goToNextPage"
      :disabled="currentPage === totalPages"> <i class="fa-solid fa-angles-right"></i></button>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  currentPage: Number,
  totalPages: Number
});

const emit = defineEmits(['changePage']);

const emitChangePage = (direction) => {
  emit('changePage', direction);
};

const goToPreviousPage = () => emitChangePage('prev');
const goToNextPage = () => emitChangePage('next');
</script>

<style scoped>
.pagination button {
  margin: 0 5px;
}
</style>
